/* eslint-disable max-classes-per-file */
import type FileUpload from "./FileUpload";
import type DocumentFileUpload from "./DocumentFileUpload";

export class FileUploadError extends Error {
  public fileUpload: FileUpload;

  constructor(message: string, fileUpload: FileUpload) {
    super(message);
    this.fileUpload = fileUpload;
    Object.setPrototypeOf(this, FileUploadError.prototype);
  }
}

export class FileUploadWrappedError<
  TError extends Error,
> extends FileUploadError {
  public originalError: TError;

  constructor(originalError: TError, fileUpload: FileUpload) {
    super(originalError.message, fileUpload);
    this.originalError = originalError;
    Object.setPrototypeOf(this, FileUploadWrappedError.prototype);
  }
}

export class DocumentFileUploadError<R> extends Error {
  public documentFileUpload: DocumentFileUpload<R>;

  constructor(message: string, documentFileUpload: DocumentFileUpload<R>) {
    super(message);
    this.documentFileUpload = documentFileUpload;
    Object.setPrototypeOf(this, DocumentFileUploadError.prototype);
  }
}

export class DocumentFileUploadWrappedError<
  TError extends Error,
  R,
> extends DocumentFileUploadError<R> {
  public originalError: TError;

  constructor(originalError: TError, fileUpload: DocumentFileUpload<R>) {
    super(originalError.message, fileUpload);
    this.originalError = originalError;
    Object.setPrototypeOf(this, DocumentFileUploadWrappedError.prototype);
  }
}
